export default __webpack_public_path__ + "static/media/login-bg.b21a1007.svg";